import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthenticationHelperService} from 'src/app/services/helpers/authentication-helper.service';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {Countries, PhoneRegex} from '../../../constants/general-variables';
import {AuthenticationHttpService} from '../../../services/http-services/authentication/authentication-http.service';
import {ToastrService} from 'ngx-toastr';
import {Meta, Title} from '@angular/platform-browser';
import {Router} from "@angular/router";

@Component({
    selector: 'app-forgot-email',
    templateUrl: './forgot-email.component.html'
})
export class ForgotEmailComponent implements OnInit {
  formTriedToSubmit = false;
  forgotForm!: FormGroup;
  isSpinnerActive = false;
  isAreaCodeOpen = false;
  selectedArea = Countries[230];
  protected readonly Countries = Countries;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private authenticationHttpService: AuthenticationHttpService,
              private authHelperService: AuthenticationHelperService,
              private toastService: ToastrService,
              private formBuilder: FormBuilder,
              private router: Router,
              private title: Title,
              private meta: Meta
  ) {
  }

  ngOnInit(): void {
    this.title.setTitle('TheLysts, List it, Live it! - Sign in now!');
    this.meta.updateTag({name: 'description', content: 'Do you know those lists you have lying around, and you dont even know where they are when you need them the most? With the books you want to buy, series you want to watch, the recipes you never managed to make… Bring them to TheLysts, sign in now!'});
    this.meta.updateTag({name: 'keywords', content: 'thelysts,lyst,list,task,organizer,connect,trip,suggestion,music,food,restaurants,sports,movies,films,tv series,podcasts,life style,cars,boats,app,recommendation,planner,beauty,fashion,celebrities,influencers,museums,golf,ongs'});
    this.meta.updateTag({property: 'og:title', content: 'TheLysts, List it, Live it! - Sign in now!'});
    this.meta.updateTag({property: 'og:image', content: 'https://thelysts.com/og-image/og-image-sign-in.jpg'});
    this.meta.updateTag({property: 'og:description', content: 'Do you know those lists you have lying around, and you dont even know where they are when you need them the most? With the books you want to buy, series you want to watch, the recipes you never managed to make… Bring them to TheLysts, sign in now!'});

    this.buildForm();
  }

  buildForm(): void {
    this.forgotForm = this.formBuilder.group({
      phone_number: ['', [Validators.pattern(PhoneRegex)]],
    });
  }

  onSubmitLoginForm(): void {
    this.formTriedToSubmit = true;
    if (this.forgotForm.valid) {
      this.isSpinnerActive = true;
      const fullNumber =
        this.selectedArea.phone_code +
        ' ' +
        this.forgotForm.controls['phone_number'].value;
      this.authenticationHttpService.postCreateNumberRegisterPostCall({
        phone_number: fullNumber
      }).then((res) => {
        this.isSpinnerActive = false;
        this.authHelperService.setUserData({
          ...this.authHelperService.getUserData,
          phone_number: fullNumber,
        });
        this.router.navigate([PAGES_AND_PATHS.verifyAccount.pagePath], {
          state: { phoneNumber: fullNumber}
        });
      })
        .catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
          this.isSpinnerActive = false;
          Object.values(error.errors).forEach((error) =>
            this.toastService.error(error[0])
          );
        });
    }
  }

  onSelectCodeArea(country: any): void {
    this.selectedArea = country;
    this.isAreaCodeOpen = false;
  }
}
